import { render, staticRenderFns } from "./Assunto.vue?vue&type=template&id=59084286&scoped=true"
import script from "./Assunto.vue?vue&type=script&lang=js"
export * from "./Assunto.vue?vue&type=script&lang=js"
import style0 from "./Assunto.vue?vue&type=style&index=0&id=59084286&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59084286",
  null
  
)

export default component.exports